import styles from "./Pets.module.css";
import Card from "../layout/Card";

import Cat from "../../img/gato.png";
import Dog from "../../img/cachorro.png";
import Birds from "../../img/aves.png";
import Animais from "../../img/animais.png";

function Pets(props) {
  return (
    <section {...props} className={styles.petsContainer}>
      <h2>Curiosidades Pets</h2>
      <div className={styles.suppliesContainer}>
        <Card
          image={Dog}
          titulo="Cachorro"
          altImage="imagem de cachorro"
          descricao="O olfato dos cachorros é 1 milhão de vezes melhor do que o dos seres humanos. Além de olfato incrível! Eles podem captar frequências até 40.000 Hz, enquanto os humanos só ouvem entre 16 e 20.000 Hz"
        />
        <Card
          image={Cat}
          titulo="Gatos"
          altImage="imagem de gato"
          descricao="A maioria dos gatos adultos desenvolve intolerância à lactose. O leite materno é a base da alimentação dos filhotes, mas após o desmame, a produção da enzima lactase diminui."
        />
        <Card
          image={Birds}
          titulo="Passaros"
          altImage="imagem de passaros"
          descricao="Beija-flores são os únicos que podem mover suas asas mais de 4,8 mil vezes por minuto e voar para trás."
        />

        <Card
          image={Animais}
          titulo="Coelhos"
          altImage="imagem de Animais"
          descricao="Coelhos são animais sociáveis que apreciam a companhia de outros coelhos. É importante considerar ter pelo menos dois coelhos juntos."
        />
      </div>
    </section>
  );
}

export default Pets;
